import "./api.d";
import { loadJS } from "@/utils/load.js"
import { setGlobalConfig } from "@seayoo-web/request";
import { toast } from "@/utils/global";
import { get, post } from "@seayoo-web/request";
import { gamerToken } from '@/utils/useGlobal';
import { getQueryString } from "@/utils/url"
import { isObject, isPlainObject } from "@seayoo-web/utils";

setGlobalConfig({
  baseURL: "",
  responseRule: {
    ok: {
      resolve: "body"
    },
    failed: {
      resolve: "json",
      messageField: "message"
    }
  },
  timeout: 30000,
  message({ code, status, message }) {
    
    if(code === "NetworkError" || code === "Failed" || code === "Aborted") {
        return "网络错误，请检查网络";
    }
    if(status === 404) {
        return "接口未定义";
    }
    if(status === 401) {
      return false;
    }
    if(status >= 500 && status <= 599) {
        return "服务器错误，请稍候再试";
    }
    if(code === "Unknown") {
        return "出现未知错误，请稍候再试";
    }
    return message || "出现未知错误，请稍候再试";
  },
  messageHandler(isError, message) {
    if(isError) {
      toast(message);
    }
  },
  errorHandler(status) {
    if (status === 401) {
      gamerToken.value = null
    }
  },
});

const eventId = SY_EVENT_ID * 1

// kms接口地址
const baseUrl = "https://jxfs.dsi.seayoo.com/";
// kms静态话接口地址
const acrticleDataURL = "https://fszl.seayoo.com/article/"
// 后端接口地址
const baseActivityUrl = !getQueryString("local") ? SY_Global_API : "";
const downloadApiUrl = !getQueryString("local") ? SY_DOWNLOAD_API : "";
const activityUrl = `${baseActivityUrl}/v1/event/${eventId}`;

const cache = Date.now()
function isConfigData<T>(data: unknown): data is IAjaxResponse<T[]> {
  return isPlainObject(data, "data")
    && isPlainObject(data.data, "items")
    && Array.isArray(data.data.items)
}
// 获取kms页面配置信息
export async function getConfigData<T>(url: string, params?: Record<string, any>) {
  const { data } = await get(`${baseUrl}${url}`,
    { guard: isConfigData<T>, message: "列表返回格式或内容错误" },
    { params:{ f: 'sn,data,created', combo: 'y', ...params } }
  );
  return (data?.data?.items || []) as T[];
}

function isContentData<T>(data: unknown): data is IAjaxResponse<DetailData> {
  return isPlainObject(data, "data") && isPlainObject(data.data, "title")
}

export async function getContentData(url: string, params?: Record<string, any>) {
  const { data } = await get(`${baseUrl}${url}`,
    { guard: isContentData, message: "返回内容错误" },
    { params:{ f: 'sn,data,created', combo: 'y', ...params } }
  );
  return (data?.data || {}) as DetailData
}

// 获取kms静态化配置列表
export function getListByPage(apiName:string, catid?:string, page?:number) {
  const key = catid || "news"
  const p = page || 1
  return loadJS(acrticleDataURL + `${apiName}/${key}_${p}.js?${cache}`).then(function() {
    const type = "_list_" + key + "_" + p;
    const totalType = "_list_" + key + "_total";
    const list = window[type];
    const total = +window[totalType] || 10
    delete window[type];
    delete window[totalType];
    return { total, list  }
  })
}

// 获取kms静态化配置详情
export function getDetail(apiName:string, sn:string) {
  return loadJS(acrticleDataURL + `${apiName}/`+ sn + ".js?"+ cache).then(function() {
    const cfg = window["_"+ sn]
    delete window["_" + sn];
    return cfg
  })
}

export function getHotNews() {
  return loadJS(acrticleDataURL + "hot.js?"+ cache).then(function() {
    const cfg = window._hot;
    delete window._hot;
    return cfg
  })
}

function isloginWithToken(data: unknown): data is ILoginWithTokenData {
  return isObject(data) && isPlainObject(data, "gamer_token")
}
// 登录身份验证
export async function loginWithToken(params: ILoginWithTokenParams) {
  const { data } = await post(`${baseActivityUrl}/v1/login-with-token`, { ...params, event_id: eventId }, { guard: isloginWithToken, message: "内容错误" });
  return data || {
    gamer_token: "",
    expires_at: 0
  }
}
function isEventConfig(data: unknown): data is IEventConfig {
  return isObject(data) && isPlainObject(data, "event_name")
}
// 获取运营活动的基础配置信息
export async function eventConfig() {
  const { data } = await get(`${activityUrl}/event-config`,
    { guard: isEventConfig, message: "内容错误"}
  );
  return data
}

function isFeatureEngagementCount(data: unknown): data is IUserEngagementsData {
  return isObject(data) && !!Object.keys(data).length;
}
// 获取某个玩法参与玩家数
export async function featureEngagementCount(params: IFeatureEngagementCountParams) {
  const { data } = await get(`${activityUrl}/feature-engagement-count`,
    { guard: isFeatureEngagementCount, message: "内容错误" }, { params: { ...params } });
  return data && data?.count || 0
}

function isEngage(data: unknown): data is IEngageData {
  return isObject(data) && isPlainObject(data, "engagement_id");
}
// 用户参与某个玩法
export async function engage(params: IEngageParams, token: string) {
  const data = await post(`${activityUrl}/engage`, params, { guard: isEngage, message: "内容错误" }, {
    headers: { "Authorization": token}
  });
  return data;
}

function isUserEngagements(data: unknown): data is IUserEngagementsData {
  return isObject(data) && isPlainObject(data, "count")
}
// 获取当前登录用户参与某个玩法的记录 用于判断是否已经预约过
export async function userEngagements(params: IUserEngagementsParams, token: string) {
  const data = await get(`${activityUrl}/user-engagements`,
    { guard: isUserEngagements, message: "内容错误" },
    { params:{ ...params },  headers: { "Authorization": token}}
  );
  return data
}

function isUserProfile(data: unknown): data is IUserProfileData {
  return isObject(data) && "user_id" in data && "mobile" in data;
}
// 获取当前登录用户基础信息
export async function userProfile(token: string) {
  const data  = await get(`${baseActivityUrl}/v1/event/user-profile`,
    { guard: isUserProfile, message: "内容错误" }, { headers: { "Authorization": token } });
  return data
}

function isWx(data: unknown): data is IResponseWx {
  return isObject(data) && isPlainObject(data, "data") && isPlainObject(data.data, "signature");
}
 // wx 分享 
 export async function getWxConfig(url: string, appId: string) {
   const { data } = await get('https://wmp-api.seayoo.com/share-sign',
     { guard: isWx, message: "内容错误" }, { params: { url, appId } })
   return data?.data || {
     signature: "",
     noncestr: "",
     timestamp: 0,
     appId:""
   };
 }

//  https://api.youxia.dev.seayoo.com/community/baidu/ocpc
export async function BaiduOcpc(params: { url: string | undefined }) {
  post(`${SY_BAIDU_API}/community/baidu/ocpc`, params);
}

function isVisit(data: unknown): data is IVisitData {
  return isObject(data) && isPlainObject(data, "first_visit");
}
// 用户访问某个活动
export async function visit(params: IVisitParams, token: string) {
  const data = await post(`${activityUrl}/visit`, { ...params },
    { guard: isVisit, message: "内容错误" },
    { headers: { "Authorization": token } });
  return data
}
// 下载信息
export async function downloadConfig(params: IDownload) {
  let url = `${downloadApiUrl}/v1/public/dl/jxfs/${params.distro}?redirect=false`
  if (params.variant) {
    url = `${downloadApiUrl}/v1/public/dl/jxfs/${params.distro}/${params.variant}?redirect=false`
  }
  const { data } = await get(url);
  return data as IDownloadData
}